import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

interface DeleteFusionConfigInput {
  clientId: string;
  configId: string;
}

/** Mutation for `DELETE /v1/clients/{clientId}/fusion-configs/{configId}` (Admin only). */
export function useDeleteFusionConfigMutation(): UseMutationResult<
  void,
  Error,
  DeleteFusionConfigInput
> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clientId, configId }: DeleteFusionConfigInput) => {
      if (!api) throw new Error('useDeleteFusionConfigMutation: api client unavailable');
      return api.delete<void>(`/v1/clients/${clientId}/fusion-configs/${configId}`);
    },
    onSuccess: (_data, { clientId }) => {
      void queryClient.invalidateQueries({ queryKey: ['fusion-configs', clientId] });
    },
  });
}
